//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import activityCheckbox from './components/checkbox.vue'
import ActivityRadio from './components/radio.vue'
export default {
  components: { activityCheckbox, ActivityRadio },
  mixins: [],
  props: {
    question: {
      type: Object,
      default() {
        return {}
      },
    },
    index: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
  },
  data() {
    return {
      currentValue: '',
    }
  },
  methods: {
    onSelectChange(flag) {
      this.$emit('onSelectChange', flag)
    },
    validate() {
      return this.$refs[`item${this.question.tenantId}`].validate()
    },
  },
}
